export const OPEN_CATEGORY_DIALOG = "OPEN_CATEGORY_DIALOG";
export const CLOSE_CATEGORY_DIALOG = "CLOSE_CATEGORY_DIALOG";

export const GET_CATEGORY = "GET_CATEGORY";
export const CREATE_NEW_CATEGORY = "CREATE_NEW_CATEGORY";
export const EDIT_CATEGORY = "EDIT_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const DELETE_ALL_CATEGORY = "DELETE_ALL_CATEGORY";

export const IS_TOP_TOGGLE = "IS_TOP_TOGGLE";

export const SET_CREATE_CATEGORY_DONE = "SET_CREATE_CATEGORY_DONE";
export const UNSET_CREATE_CATEGORY_DONE = "UNSET_CREATE_CATEGORY_DONE";

export const SET_UPDATE_CATEGORY_DONE = "SET_UPDATE_CATEGORY_DONE";
export const UNSET_UPDATE_CATEGORY_DONE = "UNSET_UPDATE_CATEGORY_DONE";
